import postWithToken from './base/post-with-token'

const customerShareVerifyEmail = (customerId, email) => {
    return postWithToken(`/customer/${customerId}/share/verify-email`)({
        email,
    })
}

export default customerShareVerifyEmail

